module.exports = __webpack_public_path__ + "static/media/salata-grebena.72fa9f34.jpg";